// extracted by mini-css-extract-plugin
export var navbarSubLink = "B_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "B_t3 d_f0 d_dB";
export var subPageLink = "B_gf d_gf";
export var burger = "B_vt";
export var sublinkSize = "B_vv";
export var linkSize = "B_vw";
export var Link = "B_sm s_sm s_rz s_rV";